// client/src/components/cursos/CursoRow.js
import React from 'react';
import { MoreVertical, GraduationCap } from 'lucide-react';
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency as formatCurrencyUtil } from '../../utils/formatters';

const CursoRow = ({ curso, onOpenActions, loading }) => {
    // ✅ ACHADO: fixo em BRL, sem ler configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();
    const formatCurrency = (value) => formatCurrencyUtil(value || 0, currency, locale);

    const formatCargaHoraria = (minutos) => {
        if (!minutos) return '—';
        const horas = Math.floor(minutos / 60);
        const min = minutos % 60;
        if (horas === 0) return `${min}min`;
        if (min === 0) return `${horas}h`;
        return `${horas}h ${min}min`;
    };

    return (
        <tr className="table-row hover:bg-gray-50 transition-colors duration-150">
            <td className="table-cell">
                <div className="flex items-center gap-3">
                    {curso.imagemUrl ? (
                        <img src={curso.imagemUrl} alt={curso.nome} className="w-10 h-10 rounded-md object-cover border flex-shrink-0" />
                    ) : (
                        <div className="w-10 h-10 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                            <GraduationCap size={18} className="text-gray-400" />
                        </div>
                    )}
                    <div className="flex flex-col">
                        <span className="font-medium text-gray-900">{curso.nome}</span>
                        {curso.descricao && (
                            <span className="text-sm text-gray-500 truncate max-w-xs">{curso.descricao}</span>
                        )}
                    </div>
                </div>
            </td>
            <td className="table-cell">
                {curso.categoria?.nome || <span className="text-gray-400 text-sm">—</span>}
            </td>
            <td className="table-cell">{formatCurrency(curso.valor)}</td>
            <td className="table-cell">{formatCargaHoraria(curso.cargaHorariaEmMinutos)}</td>
            <td className="table-cell">
                <span className={`badge ${curso.ativo ? 'badge-green' : 'badge-red'}`}>
                    {curso.ativo ? 'Ativo' : 'Inativo'}
                </span>
            </td>
            <td className="text-right">
                <button
                    onClick={() => onOpenActions(curso)}
                    className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
                    title="Ações"
                    disabled={loading}
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

export default CursoRow;
